import type { Listing } from 'app/types/listing';

interface MergeSelectedListingIdsOptions {
  currentItemIds: Listing['id'][];
  previousItemIds: ReadonlySet<Listing['id']>;
  selectedIds: Listing['id'][];
  selectAll: boolean;
  wasSelectAll: boolean;
}

export function getSelectAllListingIds({
  currentItemIds,
  isSelectAllPartial,
  selectAll,
}: Pick<MergeSelectedListingIdsOptions, 'currentItemIds' | 'selectAll'> & {
  isSelectAllPartial: boolean;
}): Listing['id'][] {
  return selectAll || isSelectAllPartial ? [] : [...currentItemIds];
}

/**
 * Keeps manual selections intact as paginated results change. While select-all is active,
 * newly loaded rows are added without re-selecting rows the user subsequently unchecked.
 */
export function mergeSelectedListingIds({
  currentItemIds,
  previousItemIds,
  selectedIds,
  selectAll,
  wasSelectAll,
}: MergeSelectedListingIdsOptions): Listing['id'][] {
  if (!selectAll) return selectedIds;

  const idsToAdd = wasSelectAll ? currentItemIds.filter((id) => !previousItemIds.has(id)) : currentItemIds;
  if (idsToAdd.length === 0) return selectedIds;

  return [...new Set([...selectedIds, ...idsToAdd])];
}
